module.exports = __webpack_public_path__ + "img/Map.90c8fa97.png";